import FaqsPage from 'components/FaqsPage';
import PageWrapper from 'components/PageWrapper';

import { getFaqsPage } from 'utils/graphcms/queries/faqsPage';
import { getLocationPaths } from 'utils/helpers';

export default function Faqs({ page }) {
  return (
    <PageWrapper page={page}>
      <FaqsPage page={page} />
    </PageWrapper>
  );
}

export async function getStaticProps({ params: { location } }) {
  const page = await getFaqsPage(location);
  return {
    props: { page },
  };
}

export const getStaticPaths = () => getLocationPaths();
